import React from "react";
import { useLanguage } from "../utils/LanguageContext";
import { useTheme } from "../utils/ThemeContext";

const Technologies = () => {
  const { t } = useLanguage();
  const { theme } = useTheme();

  return (
    <section className="py-5" id="tech">
      <div className="section-accent reveal reveal-left" />
      <h2 className={`${theme === "dark" ? "title-dark" : "title"} reveal reveal-left reveal-delay-1`}>
        {t.technoTitle}
      </h2>
      <p className="text-base md:text-lg pb-12 text-gray-400 max-w-3xl dark:text-slate-600 reveal reveal-left reveal-delay-2">
        {t.technoInfo}
      </p>

      <div className="grid grid-cols-[repeat(auto-fill,minmax(16rem,1fr))] gap-6">
        {t.technologies.map(({ icon, point, title, list, id }, index) => (
          <div
            key={id}
            className={`card-glow gradient-border bg-slate-800/80 dark:bg-white dark:shadow-sm dark:border dark:border-slate-200 rounded-xl p-6 flex flex-col gap-4 reveal reveal-scale reveal-delay-${(index % 4) + 1}`}
          >
            {/* Card header */}
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-slate-700/60 dark:bg-violet-50 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                {icon}
              </div>
              <h3 className="text-white dark:text-slate-900 font-semibold text-base">{title}</h3>
            </div>

            {/* Skill list */}
            <ul className="flex flex-col gap-y-1.5">
              {list.map((tech, i) => (
                <li key={i} className="skill-item flex items-center gap-3">
                  <span className="text-violet-400 dark:text-violet-500 text-xs flex-shrink-0 w-4 text-center leading-none">
                    {point}
                  </span>
                  <span className="text-gray-300 dark:text-slate-600 text-sm">{tech}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Technologies;
